// ═══════════════════════════════════════════════════════════════════════════
// Datos de la vinícola (el emisor) — lote 2.5
//
// El operador: "La información de las cuentas de banco, por lo menos las
// cifras, es parte de la información de la vinícola, junto con su CSF,
// domicilio de bodegas, etc."
//
// Tiene razón, y hoy no existe ese lugar: banco y CLABE están HARDCODEADOS en
// la constante REMITENTE del código. Este módulo les da un hogar editable.
//
// Es el antecesor directo de la tabla `tenant` del modelo multi-inquilino
// (MODELO-DATOS §1) y de `bank_account` (§5.2). Cuando llegue la Etapa 4, esto
// migra 1:1 — por eso cada cuenta nace con id propio.
// ═══════════════════════════════════════════════════════════════════════════

import { REMITENTE } from "../pdf/comunes.js";

const CLAVE = "vt-empresa";

/** Semilla: lo que hoy vive en el código, para no empezar en blanco. */
function semilla() {
  return {
    nombre: REMITENTE.name || "",
    rfc: REMITENTE.rfc || "",
    cuentas: REMITENTE.clabe
      ? [{
          id: "acc_semilla",
          etiqueta: `${REMITENTE.bank || "Banco"} ···${String(REMITENTE.clabe).slice(-4)}`,
          banco: REMITENTE.bank || "",
          clabe: REMITENTE.clabe || "",
          activa: true,
        }]
      : [],
  };
}

export function getEmpresa() {
  try {
    const guardado = JSON.parse(localStorage.getItem(CLAVE) || "null");
    if (guardado && Array.isArray(guardado.cuentas)) return { ...semilla(), ...guardado };
  } catch { /* datos ilegibles: se usa la semilla */ }
  return semilla();
}

export function saveEmpresa(datos) {
  try { localStorage.setItem(CLAVE, JSON.stringify(datos)); } catch (e) { console.error("empresa:", e); }
}

/** Cuentas activas, listas para ofrecer al registrar un pago. */
export function cuentasActivas() {
  return getEmpresa().cuentas.filter(c => c.activa !== false && (c.etiqueta || "").trim());
}

export function agregarCuenta({ etiqueta, banco, clabe }) {
  const e = getEmpresa();
  const cuenta = {
    id: `acc_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    etiqueta: (etiqueta || "").trim(),
    banco: (banco || "").trim(),
    clabe: (clabe || "").trim(),
    activa: true,
  };
  if (!cuenta.etiqueta) throw new Error("La cuenta necesita un nombre para identificarla.");
  const datos = { ...e, cuentas: [...e.cuentas, cuenta] };
  saveEmpresa(datos);
  return datos;
}

export function quitarCuenta(id) {
  const e = getEmpresa();
  // Baja lógica: los pagos ya registrados siguen citando esta cuenta.
  const datos = { ...e, cuentas: e.cuentas.map(c => c.id === id ? { ...c, activa: false } : c) };
  saveEmpresa(datos);
  return datos;
}
